module.exports = __webpack_public_path__ + "img/img07.ac2b1a04.svg";